/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: constants.ts
 🗓️ Created: 2025-01-27
 🧩 Description:
    Constants for CDR Settings module.
────────────────────────────────────────────────────────────────*/

import { CdrSettingsData } from './types';
import { parseDbInfoString, DEFAULT_DB_INFO_STRING } from './utils';

export const DEFAULT_CONNECTION = parseDbInfoString(DEFAULT_DB_INFO_STRING);

export const DEFAULT_SETTINGS: CdrSettingsData = {
  ...DEFAULT_CONNECTION,
  dbTable: 'cdr',
  legs: 'a',
  spoolFormat: 'csv',
  rotateOnHup: true,
  debug: false,
};

/**
 * Create empty field
 */
export function createEmptyField(sortOrder: number) {
  return {
    tempId: `temp-${Date.now()}-${Math.random()}`,
    varName: '',
    aliasName: '',
    quote: true,
    enabled: true,
    sortOrder,
  };
}

